/**
 * KA-49 §4.1 — DẢI TRẠNG THÁI HOST NEMA (tủ có card NEMA), theo mẫu `mau_van_hanh`: 5 bước
 *   Khởi động → Chờ RIIM → Mạng lên → Mạng OK → Đang quét theo `host_status.state` 0..4, kèm Online · Đã thấy · Quét điện cuối.
 * ⛔ Host vắng (> 75 s không có `host_status` — máy chủ tính `matLienLac`, `HOST_VANG_MS`) ⇒ CẢ dải xám "Mất tin host".
 *   Chưa từng có tin host ⇒ xám "Chưa có tin host" (luật số 0: không đoán bước).
 */
import { tuoiNgan, useNemaTu } from '../../lib/nemaApi';
import { BUOC_HOST, trangThaiDaiHost } from '../../lib/hostNema';

export function DaiHostNema({ cabinetId, ten, gon = false }: { cabinetId: string; ten: string; gon?: boolean }) {
  const q = useNemaTu(cabinetId);
  if (!q.data) return null;
  const h = q.data.host;
  const tt = trangThaiDaiHost(h);
  const so = (v: number | null | undefined) => (v == null || tt.xam ? '—' : String(v));
  return (
    <section className="op-dai-host khoi" data-o="dai-host" data-xam={tt.xam ? '1' : undefined} aria-label={`Trạng thái host NEMA ${ten}`}>
      <div className="op-dh-ten">
        <span>Host NEMA{h?.rf_ch != null ? ` · kênh ${h.rf_ch}` : ''}{gon ? '' : ` · ${ten}`}</span>
        <strong data-o="buoc-host">{tt.xam ? tt.cau : BUOC_HOST[tt.buoc]}</strong>
      </div>
      <ol className="op-dh-buoc" aria-hidden={tt.xam}>
        {BUOC_HOST.map((b, i) => {
          const loai = tt.xam ? 'xam' : i < tt.buoc ? 'xong' : i === tt.buoc ? 'dang' : 'chua';
          return (
            <li key={b} data-loai={loai}>
              <span className="op-dh-cham">{i + 1}</span>
              <small>{b}</small>
            </li>
          );
        })}
      </ol>
      <dl className="op-dh-so">
        <div><dt>Online</dt><dd>{so(h?.node_online)}</dd></div>
        <div><dt>Đã thấy</dt><dd>{so(h?.node_seen)}</dd></div>
        <div><dt>Quét điện cuối</dt><dd>{h?.last_sensor_s == null || tt.xam ? '—' : `${h.last_sensor_s} s`}</dd></div>
        <div className="op-dh-tin"><dt>Tin host</dt><dd>{tuoiNgan(h?.status_at ?? null)}</dd></div>
      </dl>
    </section>
  );
}
